/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { Component } from 'react';
// material
import {
    Page,
    Group,
    Copy,
    Title,
    BodyCopy,
    CTAs,
    Button,
    Link,
    Form,
    Grid,
    GridSet,
    GridItem,
    Divider,
    TextField,
    ToolTip,
    getCookie
} from '@insticator/insticator-ui'; // iui-material
import SignUpCTA from 'material/ctas/signup/signup';
// utils
import { url } from 'utils/urls';
// styles
import injectSheet from 'react-jss';
import styles from 'pages/auth/signin/signin_styles';



/* ========== ~~~~~~~~~~ AUTH SIGN IN ~~~~~~~~~~ ========== */
class SignInPage extends Component {
    constructor(props){
        super(props);
        this.formName = 'signin';
        this.state = {
            clicked: false,
            disableForm: false
        }
    }

    handleSignIn = (currentFields = this.props.fields) =>{
        // this.props.signIn;
        this.props.signIn(currentFields, this.getFormCallData(), this.handleSucessSignIn, this.handleFailedSignIn)
    };

    handleGoogleAuth = () => {
        if(this.clicked) return null;
        this.setState({ clicked: true });
        window.open(url.ppa.auth.google, '_self')
    };

    handleSucessSignIn = (response) => {
        const isMocked = response.data['mocked'];
        const isAutoLoginV2 = getCookie('auto_login_pub_portal_v2') === 'true' && !response.data['show_set_password'] && !isMocked;

        if(isAutoLoginV2) {
            this.setState({ disableForm: true })
            window.open(`https://publisher-portal.${url.baseURL}`, '_self')
        } else {
            this.props.setAuthData(response);
            this.props.discardChanges(this.formName);

            if (!!response.data['show_set_password']) {
                this.props.moveToPage('auth/completesignup')
            } else if (!!response.data['show_terms_and_condition']) {
                this.props.moveToPage('auth/acceptagreement')
            } else {
                this.props.moveToPage('dashboard/home');
            }
        }
    }

    handleFailedSignIn = (response) => {
        const errMessage = !!response && !!response.status && response.status === 401 ?
            `Woops, email or password is incorrect` :
            `Woops, something wrong: Network error. Please try again later.`;
        this.props.displayErrorMessage(errMessage);
        //Remove password and reset its validation state
        this.props.setFormFieldValue(this.formName, 'signinpassword', '');
        this.props.setFieldValidation(this.formName, 'signinpassword', null);
    };

    getFormCallData = () => ({
        email: this.props.fields.email.value,
        password: this.props.fields.signinpassword.value
    });

    fieldHandleKeyDown = (event, isValid) => {
        if (event.key === 'Enter'){
            event.preventDefault();
            return this.handleSignIn(Object.assign({}, this.props.fields, { [event.target.name]: { value: event.target.value, valid: isValid } }));
        }
    };

    render() {
        const { email, signinpassword } = this.props.fields;
        return(
            <Page name={`signin`} klass={this.props.classes.signin}>
                <Group name={`main`}>
                    <Copy>
                        <Title>
                            <h2>Sign In</h2>
                        </Title>
                        <BodyCopy>
                            <p>Sign in to access the COOL Media Dashboard</p>
                        </BodyCopy>
                    </Copy>
                    <Form name={this.formName} editable={!this.props.savingData && !this.state.disableForm}>
                        <Grid type={`fields`}>
                            <GridSet direction={`vertical`}>
                                <GridItem><TextField type={`email`} name={`email`} value={email.value} valid={email.valid} formName={this.formName} placeholder={`Email`} label={`Email Address`} info={``} handleKeyDown={this.fieldHandleKeyDown} required /></GridItem>
                                <GridItem><TextField type={`password`} name={`signinpassword`} value={signinpassword.value} valid={signinpassword.valid} formName={this.formName} placeholder={`Password`} label={`Password`} info={``} handleKeyDown={this.fieldHandleKeyDown} required /></GridItem>
                            </GridSet>
                            <GridSet direction={`horizontal`} name={`helpers`}>
                                <GridItem></GridItem>
                                <GridItem type={'full'}><Link type={`internal`} color={`primary`} action={`auth/resetpassword`} variant={`action`} name={`modal`} text={`Forgot your password?`} /></GridItem>
                            </GridSet>
                        </Grid>
                        <Divider />
                        <CTAs direction={`horizontal`}>
                            <Button type={'action'} action={this.handleSignIn} disabled={this.props.savingData || this.state.disableForm} variant={`primary`} name={`login`} text={`Log in`} />
                            <div className={`googlesignin pressed-${this.state.clicked}`} onClick={this.handleGoogleAuth} />
                            <br/>
                        </CTAs>
                    </Form>
                </Group>
                <Group name={`callout`}>
                    <SignUpCTA />
                </Group>
            </Page>
        );
    }
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(SignInPage);
